import React, { Component } from "react";

import "./App.css";
import Participant from "./Participant";
import Company from "./Company";

class App extends Component {
  render() {
    return (
      <p>
        {" "}
        <Participant />
      </p>
    );
  }
}

export default App;
